<div class="payment-result fail">

  <div class="icon-circle">
    <i class="fa-solid fa-xmark"></i>
  </div>

  <h1>{{ t('paymentFailTitle') }}</h1>

  <p>{{ t('paymentFailDesc') }}</p>

  <div class="actions">
    <a routerLink="/checkout" class="btn primary">{{ t('placeOrder') }}</a>
    <a routerLink="/" class="btn">{{ t('backToHome') }}</a>
  </div>

</div>
